// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"272":"AxisTable","642":"TTOPGeneration","712":"CSVCompare","808":"OfferManagement","864":"SKUManagement"}[chunkId] + "." + {"272":"231877e3","642":"cbbf168d","712":"f7691262","808":"4f4f79a6","864":"7f0b0c66"}[chunkId] + ".css";
};